'use client';
import styled from 'styled-components';
import { StyledMuxPlayer } from '../MuxVideo/styles';

export const StyledHeroSlide = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: ${props => props.theme.colors.get(props.$backgroundColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};

  @media ${props => props.theme.laptop} {
    min-height: 100%;
  }
`;

export const BackgroundImage = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const BackgroundVideo = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;

  ${StyledMuxPlayer} {
    width: 100%;
    height: 100%;
    aspect-ratio: unset;
    --media-object-fit: cover;
  }
`;

export const ContentContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  min-height: 480px;
  padding: ${props => props.theme.spacing(40, 6, 0)};
  max-width: 1440px;
  width: 100%;
  box-sizing: border-box;

  @media ${props => props.theme.tablet} {
    padding: 0;
    min-height: 560px;
    max-width: 90%;
  }

  @media ${props => props.theme.laptop} {
    padding: 0;
    min-height: 620px;
    max-width: 60%;
  }
  @media ${props => props.theme.laptopL} {
    padding: 0;
    min-height: 620px;
    max-width: 680px;
  }
  @media ${props => props.theme.desktop} {
    padding: 0;
    min-height: 620px;
    max-width: 680px;
  }
`;

export const PillWrapper = styled.div`
  margin-bottom: ${props => props.theme.spacing(4)};
`;

export const EyebrowWrapper = styled.div`
  margin-bottom: ${props => props.theme.spacing(2)};
  width: 100%;
`;

export const Headline = styled.div`
  ${props => props.theme.typography[props.$typography]};
  color: ${props =>
    props.$fontColor && props.theme.colors.get(props.$fontColor)};
  display: inline-block;
  width: 100%;
  overflow: hidden;

  :is(h1, h2, h3, h4, h5, h6) {
    ${props => props.theme.typography[props.$typography]};
    color: inherit;
    margin: 0;
  }

  @media ${props => props.theme.tablet} {
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

export const Subheadline = styled.div`
  ${props => props.theme.typography.heading5};
  ${({ theme }) => theme.fontFamily.base};
  margin: ${props => props.theme.spacing(4, 0)};
  color: ${props =>
    props.$fontColor && props.theme.colors.get(props.$fontColor)};
  width: 100%;

  &,
  & p,
  & span,
  & a {
    color: inherit;
  }

  @media ${props => props.theme.tabletS} {
    margin-top: ${props => props.theme.spacing(0)};
  }
`;

export const CtaWrapper = styled.div`
  width: 100%;
  max-width: 520px;
`;

export const ButtonWrapper = styled.div`
  margin: ${props => props.theme.spacing(2, 0, 8)};
  ${props => props.theme.getFocusOutline(props.$backgroundColor)};
  width: fit-content;

  @media ${props => props.theme.tablet} {
    margin: ${props => props.theme.spacing(6, 0, 0)};
  }
`;

export const InputWrapper = styled.div`
  margin-top: ${props => props.theme.spacing(20)};
  width: 110%;
  margin-left: -5%;

  @media ${props => props.theme.laptop} {
    margin-top: ${props => props.theme.spacing(10)};
  }
`;

export const AccessoryContainer = styled.div`
  display: none;
  @media ${props => props.theme.laptop} {
    display: block;
    position: absolute;
    z-index: 2;
    bottom: ${props => props.theme.spacing(10)};
    right: ${props => props.theme.spacing(10)};
  }
  @media ${props => props.theme.laptopL} {
    right: 10%;
  }
  @media (min-width: 1650px) {
    right: 15%;
  }
  @media ${props => props.theme.desktop} {
    right: 22%;
  }
`;

export const BackgroundGradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.65) 0%,
      rgba(0, 0, 0, 0.25) 50%,
      transparent 100%
    ),
    linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 100%);
`;

export const FullContentWrapper = styled.div`
  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(40, 0, 0, 25)};
  }

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(40, 0, 20, 25)};
  }
  @media (min-width: 1650px) {
    padding: ${props => props.theme.spacing(40, 0, 20, 0)};
    max-width: 1472px;
    margin: auto;
  }
`;
